var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7387 10.6097C17.7387 11.2262 17.5447 11.845 17.1567 12.3405C17.0839 12.4377 16.7444 12.8384 16.4776 13.0992L16.3321 13.2414C14.295 15.4013 9.22637 18.6493 6.65569 19.6902C6.65569 19.7139 5.12783 20.3327 4.40028 20.354H4.30328C3.1877 20.354 2.14488 19.7399 1.61134 18.7442C1.32032 18.1965 1.05355 16.608 1.0293 16.5867C0.811037 15.1618 0.665527 12.9806 0.665527 10.586C0.665527 8.0753 0.811037 5.7969 1.07781 4.39809C1.07781 4.37438 1.34457 3.09412 1.51434 2.66736C1.7811 2.05331 2.26614 1.52935 2.87243 1.19743C3.35746 0.962711 3.86675 0.841797 4.40028 0.841797C4.95807 0.867876 6.00089 1.22113 6.41317 1.3871C9.12936 2.43027 14.3192 5.84432 16.3078 7.93067C16.6474 8.2626 17.0111 8.66801 17.1082 8.76048C17.5204 9.28207 17.7387 9.9222 17.7387 10.6097Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.1431,
    y: 0.841797,
    width: 2.60163,
    height: 19.5122,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.f736a311e1d7469054681e232fc81415.svg";
export { ForwardRef as ReactComponent };